import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingIndicator from '@RHEnvironmental/pattern-library/dist/js/components/LoadingIndicator';

import { getClassNames } from '@RHEnvironmental/pattern-library/dist/js/services/stylingUtils';
import * as documentActions from '../../../actions/documents';
import { SMALL } from '../../../constants/photoSizes';

const Thumbnail = ({ photoId, getPhoto, photoUrl, className, onClick }) => {
    useEffect(() => {
        getPhoto(photoId);
    }, [getPhoto, photoId]);

    const classNames = getClassNames(className, { thumbnail: true });

    return (
        <div className={classNames} onClick={onClick}>
            {photoUrl ? <img src={photoUrl} /> : <LoadingIndicator />}
        </div>
    );
};

const mapStateToProps = (state, props) => ({
    photoUrl: state.models.photo.loaded[SMALL][props.photoId],
});

const mapDispatchToProps = (dispatch) => ({
    getPhoto(photoId) {
        dispatch(documentActions.getPhoto(photoId, SMALL));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Thumbnail);
